import { render, staticRenderFns } from "./FlexbenAffiliatePartner.vue?vue&type=template&id=298978aa&scoped=true&"
import script from "./FlexbenAffiliatePartner.vue?vue&type=script&lang=js&"
export * from "./FlexbenAffiliatePartner.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=298978aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298978aa",
  null
  
)

export default component.exports